import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateId(): string {
  return crypto.randomUUID();
}

export function xpForLevel(level: number): number {
  return Math.floor(100 * Math.pow(1.5, level - 1));
}

export function levelFromXp(xp: number): number {
  let level = 1;
  let required = 100;
  while (xp >= required) {
    level++;
    required = Math.floor(100 * Math.pow(1.5, level - 1));
  }
  return level;
}

export function teamEmoji(team: string): string {
  switch (team) {
    case "surge_squad": return "🔥";
    case "pulse_crew": return "⚡";
    case "wave_pack": return "🌊";
    default: return "✨";
  }
}

export function teamName(team: string): string {
  switch (team) {
    case "surge_squad": return "Surge Squad";
    case "pulse_crew": return "Pulse Crew";
    case "wave_pack": return "Wave Pack";
    default: return "Unknown";
  }
}

export function teamColor(team: string): string {
  switch (team) {
    case "surge_squad": return "#FF6B35";
    case "pulse_crew": return "#FFD700";
    case "wave_pack": return "#00D4FF";
    default: return "#FF6B9D";
  }
}

export function deptColor(type: string): string {
  switch (type) {
    case "marketing": return "#FF6B9D";
    case "development": return "#00D4FF";
    case "finance": return "#00C853";
    case "sales": return "#FF8C42";
    case "operations": return "#9B59B6";
    case "hr": return "#F39C12";
    case "support": return "#1ABC9C";
    case "trading": return "#E74C3C";
    default: return "#95A5A6";
  }
}
